import React, { Component } from 'react';
import {Link} from "react-router-dom";
import FlatButton from "material-ui/FlatButton/index";
import { CardActions } from 'material-ui/Card';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { NavigationArrowBack, ActionDelete, ContentCreate } from 'material-ui/svg-icons';
import FilterButton from "components/button/FilterButton";
import { List, Datagrid, FilterForm } from 'components/list';
import { TextField } from 'components/field';
import { SelectInput, TextInput} from "components/input";

import * as utils from "./utils";
import * as urls from "./urls";
import {getFrontEndUrlByFeature} from "./utils";


const cardActionStyle = {
  zIndex: 2,
  float: 'right',
};

const FunctionSwitchDetailFilter = (props) => (
  <FilterForm {...props} >
    <TextInput source="mobile_number" label="Owner mobile"/>
    <TextInput source="shop_id" label="Shop ID"/>
    <SelectInput
      source='shop_value'
      label='Function in use'
      choices={utils.SHOP_IS_ENABLED_A_FUNCTION}
      allowEmpty={true}
    />
  </FilterForm>
);

const FunctionSwitchDetailActions = (props) =>(
  <CardActions style={cardActionStyle}>
    <FlatButton
      primary label={'Add new shops'}
      icon={ <ContentAdd /> }
      style={{ float: 'left'}}
      containerElement={
        <Link to={getFrontEndUrlByFeature(urls.functionSwitchAddWhitelistFrontendPath, props.feature) } />
      }
    />
    <FlatButton
      primary label={'Back'}
      onClick={props.goBack}
      icon={ <NavigationArrowBack />}
    />
    <FilterButton />
  </CardActions>
);

const ShopIsEnabled = ({ record, ...other }) => {
  record.shop_value_text = record.shop_value === '0' ? 'No' : 'Yes';
  return (
    <TextField record={record} {...other} />
  )
};

class OperationField extends Component {

  constructor(props) {
    super(props);
    this.clickRemoveButton = this.clickRemoveButton.bind(this);
    this.clickEditButton = this.clickEditButton.bind(this);
  }

  clickRemoveButton() {
    const { record } = this.props;
    localStorage.setItem( utils.localStoreKeyForShopDataPrepareRemove, JSON.stringify(record));
  }


  clickEditButton() {
    const { record } = this.props;
    localStorage.setItem( utils.localStoreKeyForShopDataPrepareEdit, JSON.stringify(record));
  }


  render() {
    return (
      <div>
        <Link to={ getFrontEndUrlByFeature(urls.functionSwitchRemoveWhitelistFrontendPath, this.props.feature) }>
          <FlatButton onClick={this.clickRemoveButton} primary icon={<ActionDelete />} label='Remove' />
        </Link>
        {
          this.props.feature === utils.E_PAYMENT_FEATURE_ID ? 
          <Link to={ getFrontEndUrlByFeature(urls.functionSwitchEditWhitelistFrontendPath, this.props.feature) }>
            <FlatButton onClick={this.clickEditButton} primary icon={<ContentCreate />} label='Edit' />
          </Link> : null
        }
      </div>
    );
  }
}


class FunctionSwitchDetailBase extends Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    this.getFeature = this.getFeature.bind(this);
  }

  goBack() {
    this.props.history.goBack();
  }

  getFeature() {
    return 0;
  }

  render() {
    const feature = this.getFeature();
    const featureName = localStorage.getItem(utils.localStoreKeyForCurrentFeatureName);

    return (
      <List hasCreate={true}
            title={`Whitelist - ${featureName}`}
            filters={ <FunctionSwitchDetailFilter /> }
            actions={ <FunctionSwitchDetailActions feature={feature} goBack={this.goBack} /> }
            autoLoadData={true}
            {...this.props}>
        <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
          <TextField source="shop.shop_id" label="Shop ID"/>
          <TextField source="shop.shop_info.owner_mobile_number" label="Owner Mobile"/>
          <TextField source="shop.shop_info.shop_name" label="Shop Name"/>
          {
            feature === utils.E_PAYMENT_FEATURE_ID ? <TextField source="shop.shop_info.merchant_id" label="Merchant Id"/> : null
          }
          <TextField source="upd_time" label="Whitelist time" />
          <ShopIsEnabled source={'shop_value_text'} label="Enabled"/>
          <OperationField feature={feature} />
        </Datagrid>
      </List>
    )
  }
}


export class FunctionSwitchHotSlaveDetail extends FunctionSwitchDetailBase {
  getFeature() {
    return utils.HOST_SLAVE_FEATURE_ID;
  }
}

export class FunctionSwitchFoodyIntegrationDetail extends FunctionSwitchDetailBase {
  getFeature() {
    return utils.FOODY_INTEGRATION_FEATURE_ID;
  }
}

export class FunctionSwitchAutoAcceptFoodyOrdersDetail extends FunctionSwitchDetailBase {
  getFeature() {
    return utils.AUTO_ACCEPT_FOODY_ORDERS_FEATURE_ID;
  }
}

export class FunctionSwitchEpaymentDetail extends FunctionSwitchDetailBase {
  getFeature() {
    return utils.E_PAYMENT_FEATURE_ID;
  }
}

export class FunctionSwitchAssembledOrderLoadingInReportDetail extends FunctionSwitchDetailBase {
  getFeature() {
    return utils.ASSEMBLED_ORDER_LOADING_IN_REPORT_FEATURE_ID;
  }
}

export class FunctionSwitchNewMenuService extends FunctionSwitchDetailBase {
  getFeature() {
    return utils.NEW_MENU_SERVICE_ID;
  }
}


// WEBPACK FOOTER //
// ./src/routes/advancedFunction/FunctionSwitchDetail.js